import { render, staticRenderFns } from "./AutomationRulesPage.vue?vue&type=template&id=eaff378c&scoped=true&"
import script from "./AutomationRulesPage.vue?vue&type=script&lang=js&"
export * from "./AutomationRulesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaff378c",
  null
  
)

export default component.exports